import { Skeleton } from '@/components/ui/skeleton';

export function TableSkeleton({ columns = 4 }: { columns?: number }) {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-4 pb-4">
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton key={i} className={`h-8 ${i === 0 ? 'w-56' : 'w-32'}`} />
        ))}
      </div>
      {Array.from({ length: 10 }).map((_, i) => (
        <div key={i} className="flex gap-2">
          <Skeleton className="h-8 w-full" />
        </div>
      ))}
    </div>
  );
}
